import type { ClubRef } from '@rw/shared';
import { Link } from 'react-router';

export function ClubBadge({ club, size = 'md', link = true }: { club: ClubRef; size?: 'sm' | 'md' | 'lg'; link?: boolean }) {
  const s = { sm: 'size-8 text-sm', md: 'size-12 text-lg', lg: 'size-20 text-3xl' }[size];
  const badge = (
    <span className={`hex-clip grid shrink-0 place-items-center overflow-hidden font-display font-extrabold text-ink-950 ${s}`} style={{ background: club.color }} data-testid="club-badge">
      {club.logoUrl ? (
        <img src={club.logoUrl} alt="" className="size-full bg-ink-850 object-cover" loading="lazy" data-testid="club-logo" />
      ) : (
        club.name.trim().charAt(0).toUpperCase()
      )}
    </span>
  );
  return link ? <Link to={`/clubs/${club.id}`}>{badge}</Link> : badge;
}
